import React from "react";
import Header from "../components/Header";
import ServicesSection from "../components/ServicesSection";
import Footer from "../components/Footer";
import FAQ1 from "../components/FAQ1";

const OurServices = () => {
  return (
    <>
    <section
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog11.png')",
      }}
    >
      <Header/>


      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          
          {/* Title */}
          <h1 className="font-bold leading-snug text-white">
            New York Limo Service – Luxury Rides with  Majestic Voyage NYC

          </h1>

          {/* Breadcrumb */}
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Services</span>
          </div>
        </div>
      </div>
    </section>
    {/* Premier Service Section - Mobile: Image First, Desktop: Image Left, Text Right */}
      <section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Image Side - First on mobile, left on desktop */}
            <div className="order-1 lg:order-1">
              <img 
                src="fleet6.png" 
                alt="Luxury Fleet" 
                className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Text Side - Second on mobile, right on desktop */}
            <div className="order-2 lg:order-2">
              <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
                New York Limo Service – Luxury Rides with  Majestic Voyage NYC
              </h2>
              <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
               Looking for a stylish limo service in New York City? Drink to Majestic Voyage NYC, the most trusted
               name for luxury chauffeur service in NYC.
               We offer ultraexpensive limousines, black buses, and administrative SUVs for field transfers,
                weddings, business trip, events, and nights out.

              </p>
              <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
              Our New York limo service is each about comfort, finesse, and professionalism. Whether you're
              a original, sightseer, or commercial rubberneck, we make sure your lift through New York feels
              smooth, swish, and stress-free.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Top-Rated Service Section */}
<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Top-Rated Limo Service NYC – Travel in Style
        </h2>
        <p className="  mb-2 sm:mb-2 leading-relaxed text-gray-900">
          At Majestic Voyague NYC, we do n't just give transportation — we deliver a luxury experience from
          volley to drop- off. Every trip is substantiated, immediate, and handled by trained motorists who
          know every corner of New York City.
        </p>
        <p className="mb-2 sm:mb-2 leading-relaxed text-gray-900">
          With our New York limousines, you'll enjoy a first-class experience no matter the occasion. From
          field transfers to Manhattan tenures, we ensure your trip is flawless, safe, and elegant
        </p>
        <p className="mb-2 sm:mb-2 leading-relaxed text-gray-900">
          Our Professional New York Limousine Services
        </p>
        <p className="mb-2 sm:mb-2 leading-relaxed text-gray-900">
          We serve individuals, families, business professionals, and event organizers with our full range
          of NYC limo services.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Luxury Fleet" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

    <ServicesSection/>
    
    {/* Luxury Fleet Section */}
    <section className="bg-white py-8 sm:py-12 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Image Side - First on mobile, left on desktop */}
          <div className="order-1 lg:order-1">
            <img 
              src="blog11.png" 
              alt="Luxury Fleet" 
              className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Text Side - Second on mobile, right on desktop */}
          <div className="order-2 lg:order-2">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black mb-3 sm:mb-4 leading-tight">
              Our Luxury Fleet
            </h2>
            <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
              We maintain one of the most diverse and high-end limo fleets in New York. Each vehicle is
              designed for comfort, luxury, and safety.
            </p>
            
            <h3 className="font-semibold text-gray-800 mb-3">
              Choose from:
            </h3>
            
            {/* Fleet Options List */}
            <div className="space-y-3 mb-4 sm:mb-6">
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <div>
                  <span className="font-semibold text-gray-800">Stretch Limousines</span>
                  <span className="text-black"> – Ideal for weddings and special events</span>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <div>
                  <span className="font-semibold text-gray-800">Executive Sedans</span>
                  <span className="text-black"> – Perfect for business and airport transfers</span>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <div>
                  <span className="font-semibold text-gray-800">SUVs and Black Buses</span>
                  <span className="text-black"> – Spacious, elegant, and comfortable</span>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <div>
                  <span className="font-semibold text-gray-800">Sprinter Vans & Party Buses</span>
                  <span className="text-black"> – For groups, tours, and celebrations</span>
                </div>
              </div>
            </div>
            
            <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
              Every New York limo in our fleet is fully insured, air-conditioned, and equipped with plush 
              interiors, Wi-Fi, music systems, and refreshments.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/fleet"
                className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
              >
                VIEW ALL FLEETS
              </a>
              <a 
                href="tel:+17182004140" 
                className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
              >
                CALL NOW
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Why Choose Us Section */}
    <section className="bg-white py-8 sm:py-12 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Text Side - First on mobile, left on desktop */}
          <div className="order-1 lg:order-1">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black mb-3 sm:mb-4 leading-tight">
              Why Majestic Voyague NYC  is the Best Limo Service in New York
            </h2>
            <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
              When you ride with us, you're choosing reliability, class, and convenience.
              That's why thousands trust our limo service in NYC every month.
            </p>
            
            {/* Features Grid */}
            <div className="grid grid-cols-1 gap-3 mb-6">
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span className="text-sm sm:text-base">Professional Drivers: Trained, certified, and polite drivers</span>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span className="text-sm sm:text-base">On-Time Pickup Guarantee: We value your time</span>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span className="text-sm sm:text-base">24/7 Service: Day or night, we're always available</span>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span className="text-sm sm:text-base">Transparent Pricing: No hidden fees, no surprises</span>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span className="text-sm sm:text-base">Clean & Sanitized Vehicles: Hygiene and safety first</span>
              </div>
              <div className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span className="text-sm sm:text-base">Instant Booking: Reserve online or through our hotline instantly</span>
              </div>
            </div>
            
            <p className="text-base sm:text-lg mb-2 sm:mb-3 leading-relaxed font-semibold text-gray-900">
              Our thing is simple — to make New York transportation luxurious and royal.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/booknow" 
                className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
              >
                BOOK NOW
              </a>
              <a 
                href="tel:+17182004140" 
                className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
              >
                CALL NOW
              </a>
            </div>
          </div>

          {/* Image Side - Second on mobile, right on desktop */}
          <div className="order-2 lg:order-2">
            <img 
              src="blog13.png" 
              alt="Luxury Limo Service" 
              className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Key Features Section */}
    <section className="bg-gradient-to-br from-gray-900 to-black py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="font-bold text-white mb-4">
            Key Features at a Glance
          </h2>
          <p className="text-gray-300 max-w-3xl mx-auto">
            Everything you need to know about Majestic Voyague NYC  premium services
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Fleet Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Fleet</h3>
            <p className="text-gray-300">
              Limousines, luxury sedans, SUVs, party buses
            </p>
          </div>

          {/* Service Areas Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Service Areas</h3>
            <p className="text-gray-300">
              All NYC boroughs, JFK/LGA/EWR airports, Long Island, NJ
            </p>
          </div>

          {/* Availability Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Availability</h3>
            <p className="text-gray-300">
              24/7 professional chauffeurs and customer support
            </p>
          </div>

          {/* Bookings Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72v4h2v-4h2v4h2v-4c0-.74-.4-1.37-1-1.72V8h3v10h2V6zm-7 1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Bookings</h3>
            <p className="text-gray-300">
              Online, telephone, special requests accommodated
            </p>
          </div>

          {/* Safety Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Safety</h3>
            <p className="text-gray-300">
              Background checks, training, latest vehicle safety features
            </p>
          </div>

          {/* Special Services Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Special Services</h3>
            <p className="text-gray-300">
              Weddings, corporate events, airport transfers, nightlife
            </p>
          </div>

          {/* Customer Satisfaction Feature */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-white transition-all duration-300 hover:shadow-2xl hover:shadow-white/10 flex flex-col items-center justify-center text-center">
            <div className="text-white mb-4">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
              </svg>
            </div>
            <h3 className="font-bold text-white mb-2">Customer Satisfaction</h3>
            <p className="text-gray-300">
              High ratings for promptness, vehicle condition, courteousness
            </p>
          </div>

          {/* CTA Card */}
          <div className="bg-gray-800/50 rounded-xl p-6 col-span-1 md:col-span-2 lg:col-span-4">
            <div className="flex flex-col md:flex-row items-center justify-between text-center md:text-left">
              <div className="mb-4 md:mb-0 md:mr-6">
                <h3 className="font-bold text-white mb-2">Ready to Book Your Luxury Ride?</h3>
                <p className="text-white/90">
                  Experience the ultimate in New York luxury transportation
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-bold  transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black px-6 sm:px-8 py-3 font-bold hover:bg-gray-100 transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Affordable Luxury Section */}
    <section className="bg-white py-8 sm:py-12 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Image Side - First on mobile, left on desktop */}
          <div className="order-1 lg:order-1">
            <img 
              src="fleet6.png" 
              alt="Luxury Limo Service" 
              className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Text Side - Second on mobile, right on desktop */}
          <div className="order-2 lg:order-2">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black mb-3 sm:mb-4 leading-tight">
              Experience Luxury in Every Mile – Best Limo Prices in NYC
            </h2>
            <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
              Luxury doesn't have to be expensive. At Majestic Voyague NYC, we offer experience luxury in every mile service NYC
              packages that fit your budget.
            </p>
            <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
              Whether you need an auto service NYC for an hour or a full-day limousine rental, our
              pricing is clear and competitive.
            </p>
            <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
              We believe every client deserves ultra-expensive comfort without overpaying. You can request
              a free quotation online and get the best deal for your next ride.
            </p>

            <div className="mb-6 sm:mb-8">
              <h3 className="font-semibold text-gray-800 mb-4">Reserving Your Limo Made Easy</h3>
              
              {/* Booking Steps */}
              <div className="space-y-3 mb-4">
                <div className="flex items-start">
                  <span className="bg-black text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0 mt-1">1</span>
                  <span className="text-sm sm:text-base">Visit our website or call our support line.</span>
                </div>
                <div className="flex items-start">
                  <span className="bg-black text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0 mt-1">2</span>
                  <span className="text-sm sm:text-base">Choose your vehicle type and service (airport, wedding, event, or hourly).</span>
                </div>
                <div className="flex items-start">
                  <span className="bg-black text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0 mt-1">3</span>
                  <span className="text-sm sm:text-base">Confirm details – pickup, drop-off, and special requests.</span>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/booknow" 
                className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
              >
                BOOK NOW
              </a>
              <a 
                href="tel:+17182004140" 
                className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
              >
                CALL NOW
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Testimonials Section */}
    <section className="bg-white py-8 sm:py-12 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Text Side - First on mobile, left on desktop */}
          <div className="order-1 lg:order-1">
            <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
              Enjoy your ride in a clean, luxurious New York limousine.
            </h2>
            <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
              Our 24/7 client support team ensures a smooth booking process from start to finish.
            </p>
            <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
              What Is the Best Limo Service in New York?
            </h2>
            <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
              The best limo service in New York is Majestic Voyague NYC , known for luxury vehicles,
              professional drivers, and affordable rates. We offer airport transfers, business trips,
              weddings, and event transportation across NYC, Long Island, and New Jersey.
            </p>
            
            
            
           
          </div>

          {/* Image Side - Second on mobile, right on desktop */}
          <div className="order-2 lg:order-2">
            <img 
              src="blog12.png" 
              alt="Luxury Limo Service" 
              className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
      

    <FAQ1/>
    <Footer/>
    </>
  );
};

export default OurServices;
